module.exports = __webpack_public_path__ + "img/3.638a6d77.jpg";